import { render, staticRenderFns } from "./faculty.vue?vue&type=template&id=b2560ed6"
import script from "./faculty.vue?vue&type=script&lang=js"
export * from "./faculty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports